export default "__VITE_ASSET__26bKVjAS__"